export default "/images/vendor/flag-icon-css/flags/1x1/pe.svg?83c26459858b4334c435886c37cc8379";